import React, { useEffect } from 'react';

// Set your AdSense Publisher ID here when ready
const ADSENSE_PUBLISHER_ID = process.env.REACT_APP_ADSENSE_PUBLISHER_ID || '';

// Check if AdSense is properly configured
const isAdSenseConfigured = () => {
  return ADSENSE_PUBLISHER_ID && 
         ADSENSE_PUBLISHER_ID !== '' && 
         ADSENSE_PUBLISHER_ID !== 'ca-pub-XXXXXXXXXX' &&
         ADSENSE_PUBLISHER_ID.startsWith('ca-pub-');
};

export const AdBanner = ({ slot = "auto", format = "auto", className = "" }) => {
  useEffect(() => {
    if (!isAdSenseConfigured()) return;
    
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) { 
      console.log('AdSense error:', e); 
    }
  }, []);

  // Don't render anything if AdSense is not configured
  if (!isAdSenseConfigured()) {
    return null;
  }

  return (
    <div className={`ad-container ${className}`}>
      <ins className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={ADSENSE_PUBLISHER_ID}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"></ins>
    </div>
  );
};

// Export the check function for other components to use
export const isAdsEnabled = isAdSenseConfigured;
